import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A3A24] px-4 py-12 text-center text-sm text-white/60" data-id="element-68" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-69" data-mp="3gg0yw2enzvx4">
        <div className="mb-3 flex items-center justify-center gap-2" data-id="element-70" data-mp="3gh3n22klrk9c">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/30682d48-c99b-4b6c-bbf3-b8a560147d71.jpg" alt="" className="h-8 w-8 rounded-full bg-white object-cover" data-id="element-71" data-mp="32pp6s3i2xx5z" />
          <span className="font-serif text-xl font-bold text-white" data-id="element-72" data-mp="3ud7czjog16g0">BIOLOGIA PRONTA</span>
        </div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-73" data-mp="3lecbgkwcgkj1">
          Il curriculum completo di Scienze pronto all’uso per la scuola primaria e secondaria di primo grado.
        </p>
        <nav aria-label="Legale" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-74" data-mp="29z6ucbvgujfw">
          <a href="#termini" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-75" data-mp="2ey09s9ubckip">
            Termini e Condizioni
          </a>
          <a href="#privacy" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-76" data-mp="3la2akxul99wt">
            Privacy
          </a>
        </nav>
        <p data-id="element-77" data-mp="3v7q6hr3xkngk">© 2026 Biologia Pronta. Tutti i diritti riservati.</p>
      </div>
    </footer>;
}